import * as React from "react";
import { useCallback } from "react";
import { Button } from "components/bootstrap";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
function ClearSelection() {
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const cancelEntitySelection = useCallback(() => setSelectedEntities([]), [setSelectedEntities]);
  return selectedEntities.length > 0 ? /* @__PURE__ */ React.createElement(Button, { bsSize: "sm", onClick: cancelEntitySelection }, "Clear All") : null;
}
export default ClearSelection;
